import { Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import React, { Component } from 'react'
import { TranslationFunction } from 'react-i18next'

import { i18nKeys } from '../../../app/app.i18n'
import { EmojiSelector, identity } from '../../../app/shared/'

type Props = {
  toolbarId: string
  isSmallEditor: boolean
  translate?: TranslationFunction
  onEmojiSelect(emoji: string): void
  onStripHtml(): void
}

export class HtmlToolbar extends Component<Props> {
  render() {
    const { isSmallEditor, toolbarId, onEmojiSelect, translate = identity, onStripHtml } = this.props

    return (
      <div id={toolbarId} className="d-none d-sm-block">
        {!isSmallEditor && (
          <select
            className="ql-size"
            defaultValue="normal"
            title={translate(i18nKeys.frontFace.htmlEditor.textSizeTooltip)}
          >
            <option value="small" />
            <option value="normal" />
            <option value="large" />
            <option value="huge" />
          </select>
        )}
        <span className="ql-formats">
          <button className="ql-bold" title="bold" />
          <button className="ql-italic" title="italic" />
          <button className="ql-strike" title={translate(i18nKeys.frontFace.htmlEditor.strikeTooltip)} />
          {!isSmallEditor && (
            <button className="ql-blockquote" title={translate(i18nKeys.frontFace.htmlEditor.blockquoteTooltip)} />
          )}
        </span>
        <span className="ql-formats">
          <button
            className="ql-list"
            value="ordered"
            title={translate(i18nKeys.frontFace.htmlEditor.orderedListTooltip)}
          />
          <button
            className="ql-list"
            value="bullet"
            title={translate(i18nKeys.frontFace.htmlEditor.bulletListTooltip)}
          />
          <button
            className="ql-indent"
            value="-1"
            title={translate(i18nKeys.frontFace.htmlEditor.indentMinusTooltip)}
          />
          <button className="ql-indent" value="+1" title={translate(i18nKeys.frontFace.htmlEditor.indentPlusTooltip)} />
        </span>
        <span className="ql-formats">
          <EmojiSelector onSelect={onEmojiSelect} className="comment__emoji" translate={translate} />
        </span>
        <span className="ql-formats">
          <button className="ql-clean" title={translate(i18nKeys.frontFace.htmlEditor.removeFormattingTooltip)} />
        </span>
        <span className="ql-formats">
          <button onClick={onStripHtml} className="strip-html" type="button">
            <Icon icon={IconNames.TICK} iconSize={12} title={translate(i18nKeys.frontFace.htmlEditor.validateHtml)} />
          </button>
        </span>
      </div>
    )
  }
}

export default HtmlToolbar



// WEBPACK FOOTER //
// ./src/modules/forms/components/html-toolbar.tsx